var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.43442 3.43439C3.58445 3.28441 3.78789 3.20016 4.00002 3.20016C4.21216 3.20016 4.4156 3.28441 4.56562 3.43439L8.00002 6.86879L11.4344 3.43439C11.5082 3.35798 11.5965 3.29703 11.6941 3.2551C11.7917 3.21318 11.8967 3.19111 12.0029 3.19019C12.1091 3.18926 12.2145 3.2095 12.3128 3.24973C12.4111 3.28995 12.5004 3.34936 12.5755 3.42447C12.6507 3.49958 12.7101 3.58891 12.7503 3.68722C12.7905 3.78554 12.8107 3.89088 12.8098 3.99711C12.8089 4.10333 12.7868 4.20831 12.7449 4.30591C12.703 4.40351 12.642 4.49179 12.5656 4.56559L9.13122 7.99999L12.5656 11.4344C12.7114 11.5853 12.792 11.7873 12.7902 11.9971C12.7883 12.2069 12.7042 12.4075 12.5559 12.5558C12.4076 12.7042 12.2069 12.7883 11.9971 12.7901C11.7874 12.7919 11.5853 12.7113 11.4344 12.5656L8.00002 9.13118L4.56562 12.5656C4.41474 12.7113 4.21266 12.7919 4.0029 12.7901C3.79315 12.7883 3.5925 12.7042 3.44417 12.5558C3.29584 12.4075 3.21171 12.2069 3.20989 11.9971C3.20806 11.7873 3.2887 11.5853 3.43442 11.4344L6.86882 7.99999L3.43442 4.56559C3.28445 4.41556 3.2002 4.21212 3.2002 3.99999C3.2002 3.78785 3.28445 3.58441 3.43442 3.43439Z",
    fill: "#09090B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/X.76a172133b2671be1b925fdb27b36b67.svg";
export { ForwardRef as ReactComponent };